/**
 * CPF Validator
 * Validates Brazilian CPF (Cadastro de Pessoas Físicas) numbers
 */

export class CpfValidator {
  /**
   * Validates a CPF number
   * @param cpf - CPF string (can be formatted or unformatted)
   * @returns true if valid, false otherwise
   */
  static isValid(cpf: string): boolean {
    if (!cpf) return false;

    // Remove non-numeric characters
    const cleanCpf = cpf.replace(/\D/g, '');

    // Check if has 11 digits
    if (cleanCpf.length !== 11) return false;

    // Check if all digits are the same (invalid CPF)
    if (/^(\d)\1{10}$/.test(cleanCpf)) return false;

    // Validate first check digit
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
    }
    let digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cleanCpf.charAt(9))) return false;

    // Validate second check digit
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
    }
    digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cleanCpf.charAt(10))) return false;

    return true;
  }

  /**
   * Gets error message for invalid CPF
   */
  static getErrorMessage(): string {
    return 'CPF inválido';
  }
}
